/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiBadge, EuiText } from '@elastic/eui'

import type { InstanceConfiguration } from '@modules/cloud-api/v1/types'
import type { AnyTopologyElement } from '@modules/ui-types'

import type { ReactElement } from 'react'

export default function WithTopologyElement({
  children,
  topologyElement,
  instanceConfiguration,
}: {
  children: ReactElement<any>
  topologyElement: AnyTopologyElement | undefined
  instanceConfiguration: InstanceConfiguration
}): JSX.Element | null {
  if (!instanceConfiguration) {
    return children
  }

  const badge = topologyElement?.id || instanceConfiguration.name

  return (
    <EuiText size='s'>
      {children} <EuiBadge color='hollow'>{badge}</EuiBadge>
    </EuiText>
  )
}
